import {
  getRequiredObjectId,
  locationHistorySelector,
  ShiftEntity,
  useGetShiftLocationHistoryQuery
} from "@ots-frontend/ots-data";
import {ShiftLocationHistory} from "../model/location-history";
import {useMemo} from "react";
import {getShiftLocationHistory} from "../components/map/LocationHistoryMap/util";


export type UseGetShiftLocationHistoryProps = {
  shift: string | ShiftEntity,
  database?: string
}

export type UseGetShiftLocationHistoryResult = {
  history?: ShiftLocationHistory
  isLoading?: boolean
}

export const useGetShiftLocationHistory = (props: UseGetShiftLocationHistoryProps): UseGetShiftLocationHistoryResult => {
  const {
    shift,
    database,
  } = props;

  const shiftId = useMemo(() => {
    return getRequiredObjectId(shift)
  }, [shift])

  const databaseValue = useMemo(() => {
    if (database) {
      return database
    }

    if (typeof shift === 'string') {
      return database
    } else {
      return shift?.database
    }
  }, [database, shift])

  const selectLocationHistory = useMemo(() => {
    return locationHistorySelector()
  }, []);

  const {locationHistory, isLoading} = useGetShiftLocationHistoryQuery({
    id: shiftId,
    database: databaseValue,
  }, {
    selectFromResult: (result) => ({
      locationHistory: selectLocationHistory(result),
      isLoading: result.isFetching,
    })
  });

  const shiftLocationHistory: ShiftLocationHistory | undefined = useMemo(() => {
    return locationHistory && locationHistory.shifts.length > 0 ? getShiftLocationHistory(locationHistory, locationHistory.shifts[0].id) : undefined
  }, [locationHistory])

  return {
    history: shiftLocationHistory,
    isLoading: isLoading,
  };
};
